module.exports = __webpack_public_path__ + "static/media/stem-owl-2.61dd1ad9.png";